const finance = {
  customerName: '客户名称',
  customerIdCard: '身份证',
  customerTel:'手机号',
  serviceType: '是否维护单',
  orderUserNo: '业务员',
  customOrderNo: '订单编号',
  completionDate: '成交日期',
  presentationFlag: '是否交单',
  presentationDate: '交单日期',
  marketNo: '市场',
  productName: '产品',
  totalGroupFunds: '总团款',
  wechatDeposit: '微信定金',
  alipayDeposit: '支付宝定金',
  corporateDeposit: '对公定金',
  joiningAreasName: '对公地接社',
  collectionAmount: '代收',
  operationAreasNo: '操作地接社',
  settlementPrice: '结算价',
  receivables: '应收款',
  companyExpenses: '公司支出',
  areasExpenses: '地接社支出',
  expensesAreasNo: '支出地接社',
  totalProfit: '总利润',
  travelDate: '行程日期',
  travelStatus: '行程状态',
  remark: '备注',
  msg:{
    serviceType: '请选择是否维护单!',
    customOrderNo: '请填写订单编号!',
    completionDate: '请选择成交日期!',
    presentationDate: '请选择交单日期!',
    marketNo: '请选择市场!',
    productName: '请填写产品!',
    totalGroupFunds: '请填写总团款!',
    wechatDeposit: '请填写微信定金!',
    alipayDeposit: '请填写支付宝定金!',
    corporateDeposit: '请填写对公定金!',
    joiningAreasName: '请选择对公地接社!',
    operationAreasNo: '请选择操作地接社!',
    settlementPrice: '请填写结算价!',
    companyExpenses: '请填写公司支出!',
    areasExpenses: '请填写地接社支出!',
    expensesAreasNo: '请选择支出地接社!',
    travelDate: '请选择行程日期!',
  }
};
export default finance



// WEBPACK FOOTER //
// ./src/page/zhubo/finance/lang/finance.en.js